import React from 'react';

import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import ErrorOutlineIcon from '@material-ui/icons/ErrorOutline';

interface IErrorProps {
    error?: string | Error;
    message?: string;
}

export const Error = ({ error, message }: IErrorProps) => {
    let msg = '';
    if (message) {
        msg = message;
    } else if (typeof error === 'string') {
        msg = error;
    } else if (error) {
        msg = error.message;
    }
    return <Box>
        <ErrorOutlineIcon />
        <Typography variant="body2">{`Sorry, something went wrong: ${msg}`}</Typography>
    </Box>
};

export default Error;
